<template>
  <nav-bar title="待检测任务钢瓶" />
  <div class="search-container">
    <van-search
      v-model="gsCode"
      placeholder="请输入搜索气瓶编号"
      :clearable="false"
      @search="onSearch"
      @cancel="onCancel"
      autofocus
    />
  </div>
  <Content :bottom="0" :top="100" @content-scroll="handleContentScroll">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul class="list">
      <li class="list-item" v-for="item in list" :key="item.gsId">
        <div class="row">
          <span>气瓶编号：{{ item.gsId }}</span>
          <van-button
            type="primary"
            size="mini"
            @click="
              $router.push(`/editTaskCylinder/${item.cId}-${item.cMedium}`)
            "
            >编辑</van-button
          >
        </div>
        <div class="row">批次号： {{ item.batchNo }}</div>
        <div class="row">送检单位：{{ item.sendUnit }}</div>
      </li>
    </ul>
    <loading-more
      :finished="finished"
      :showLoadingMore="showLoadingMore"
      :loadingFail="loadingFail"
      :list="list"
      @reload="reload()"
    />
  </Content>
</template>

<script>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { getCheckCylinderListByUserIdForApp } from '@/api/cylinderManageUserHome'
import { useLoadingMore } from '@/hooks/useLoadingMore'
export default {
  name: 'SearchTaskCylinder', // 搜索任务钢瓶
  setup(props) {
    const store = useStore()
    const empId = computed(() => store.state.roleInfo.empId)
    const companyId = computed(() => store.state.roleInfo.companyId)
    const data = useLoadingMore(getCheckCylinderListByUserIdForApp)
    const { getList, list, finished, loadingFail, pageParams } = data
    const gsCode = ref('')
    // 初始化list
    const init = () => {
      list.value = []
      pageParams.page = 1
      pageParams.gsCode = gsCode.value
      pageParams.userId = empId.value
      pageParams.companyId = companyId.value
      finished.value = false
      loadingFail.value = false
      // getList()
    }
    init()
    const onSearch = () => {
      init()
      getList()
    }
    const onCancel = () => {
      gsCode.value = ''
      list.value = []
    }
    return {
      ...data,
      getList,
      gsCode,
      onSearch,
      onCancel
    }
  }
}
</script>

<style lang="scss" scoped>
.search-container {
}
.list {
  padding: 0 16px;
  font-size: 14px;
  .list-item {
    background-color: #fff;
    padding: 10px 16px;
    margin-top: 16px;
    border-radius: 5px;
    line-height: 26px;
    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
.notice-content {
  font-size: 14px;
  line-height: 26px;
  color: #333;
  padding: 16px;
}
</style>
